import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=c0a1a8b8&scoped=true&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"
import style0 from "./Account.vue?vue&type=style&index=0&id=c0a1a8b8&lang=scss&scoped=true&"
import style1 from "./Account.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a1a8b8",
  null
  
)

export default component.exports